/*
 * @Author: llzq
 * @Date: 2021-10-24 13:32:01
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:44:19
 * @Description:  头部注释
 */
import React, { Component } from 'react'
import {TreeSelect} from 'antd'
import AppService from "../service/app.service";
import CommonTree from '../models/commonTree'

const { TreeNode } = TreeSelect;

interface iProps {
    value?: string;
    onChange?: (value: string) => void;
}
interface iState {
    treeList: CommonTree[]
}

export default class buildingSelector extends Component<iProps, iState> {
    private appService: AppService = new AppService();
    state:iState = {
        treeList:[]
    }
    // 获取部门列表
    getDepartmentList = async () => {
        let data = await this.appService.getBuildingsSelector()
        let treeData = this.iterationTree(data)
        this.setState({treeList: treeData})
    }
    handleChange = (value: string) => {
        this.props.onChange(value);
    };
    iterationTree = (data:CommonTree[]) =>{
        data && data.length && data.map((item) => {
            item.title = item.name
            item.key  = item.id
            item.children  = item.subNodes
            item.value  = item.id //+ '|' + item.type
            item.subNodes && item.subNodes.length && this.iterationTree(item.subNodes)
        })
        return data
    }
    componentDidMount () {
        this.getDepartmentList()
    }
    render() {
        let {treeList} = this.state
        let {value} = this.props
        treeList = treeList || []
        return (
            <TreeSelect
                showSearch
                style={{ width: '100%' }}
                value={value}
                // treeData={treeList}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="请选择楼宇"
                allowClear
                multiple={true}
                treeDefaultExpandAll = {false}
                onChange={this.handleChange}
            >
                {treeList.map(tree => {
                    return <TreeNode value={tree.value} title={tree.title} key={tree.key} selectable={false}>
                        {
                            tree.children && tree.children.length && tree.children.map(children => {
                               return  <TreeNode value={children.value} title={children.title} key={children.key}></TreeNode>
                            })
                        }
                    </TreeNode>
                })}
            </TreeSelect>
        )
    }
}
